export default "__VITE_ASSET__d2de597c__"